import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

// ✅ Helper to limit characters for excerpt
const limitParagraphByCharLimit = (html = "", limit = 200) => {
  if (!html) return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const text = (doc.body.textContent || "").trim();
  if (text.length <= limit) return text;
  return text.slice(0, limit).trimEnd();
};

function CardCarouselReviews() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      setReviewsData(response?.data || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center mt-5">
          <Spinner />
        </div>
      ) : reviewsData?.length === 0 ? (
        <div className="text-center mt-5">No Reviews Available</div>
      ) : (
        <div className="container mt-5 mb-5">
          <div className="row">
            <div className="offset-md-2 col-md-8 text-center mb-5">
              <h2 className="section-title mb-0 text-uppercase">
                Patient <span className="theme-color">Reviews</span>
              </h2>
              <span className="section-border-bottom center"></span>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <OwlCarousel
                className="owl-theme"
                loop={true}
                nav={false}
                dots={false}
                autoplay={true}
                autoplayTimeout={3000}
                smartSpeed={1000}
                margin={30}
                center={true}
                responsive={{
                  0: { items: 1 },
                  576: { items: 1 },
                  768: { items: 1 },
                  992: { items: 1 },
                  1200: { items: 1 },
                }}
              >
                {reviewsData.map((data, index) => {
                  const charLimit = window.innerWidth < 768 ? 70 : 200;
                  const isLong = (data?.detail || "").length > charLimit;
                  return (
                    <div
                      key={index}
                      className="item animated fadeInRight visible"
                    >
                      <div className="testimonial-style-2 carousal-card-border">
                        <div className="testimonial-inner">
                          <div className="testimonial-details text-left">
                            <div
                              className="testimonial-description margin-top-15"
                              style={{
                                minHeight: "100px",
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <p className="mb-4 pb-1 desription-card-carousal-reviews">
                                {limitParagraphByCharLimit(data?.detail, charLimit)}
                                {isLong && (
                                  <>
                                    ...{" "}
                                    <Link
                                      onClick={() => handleShowMore(data)}
                                      className="fw-bold"
                                      style={{ color: "#fff" }}
                                    >
                                      See More
                                    </Link>
                                  </>
                                )}
                              </p>
                            </div>

                            <div className="client-details text-left left-align d-flex align-items-center">
                              <div className="client-image">
                                <img
                                  className="img-circle"
                                  src={
                                    data?.profile_image || "/assets/img/no-image.png"
                                  }
                                  style={{ width: "65px", height: "65px" }}
                                  width="65"
                                  height="65"
                                  alt={data?.full_name || "Reviewer"}
                                />
                              </div>
                              <div className="client-info ms-3">
                                <h5 className="mb-1">{data?.full_name}</h5>
                                {data?.position && <span>{data.position}</span>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            </div>
            <div className="col-md-2"></div>
          </div>
        </div>
      )}

      {/* Modal for full review */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{ __html: selectedReview?.detail || "" }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CardCarouselReviews;
